// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608190612/js/" + chunkId + "." + {"44":"dc4c4cec","225":"7d77cf08","481":"f29a8b2d","486":"43cd6250","770":"e067f6ad"}[chunkId] + ".0.38839248466445875.chunk.js";
};